<template>
  <section class="batch-modify">
    <header class="batch-head">
      <div class="crumb"><button class="plain" @click="$emit('back')">‹ 返回</button><span>商品工作台　›　批量修改　›　<strong>商品主图</strong></span></div>
      <h1>批量修改商品主图</h1>
      <nav><button v-for="tab in tabs" :key="tab.value" :class="[{ active: mode === tab.value }, `mode-${tab.value}`]" @click="switchMode(tab.value)">{{ tab.label }}</button></nav>
    </header>
    <main>
      <section class="panel">
        <div v-if="mode === 'products'" class="picked"><button @click="openSelector">选择商品</button><span>已选择 <b>{{ selected.length }}</b> 个商品</span></div>
        <div v-else-if="mode === 'product_ids'" class="ids"><label>抖店商品 ID</label><el-input v-model="idsText" type="textarea" :rows="3" placeholder="多个 ID 用逗号、空格或换行分隔" /></div>
        <template v-else>
          <div class="filters">
            <label v-for="field in shownFields" :key="field.key" class="field"><span>{{ field.label }}</span>
              <doudian-category-cascader v-if="field.key === 'category_id'" v-model="filters.category_id" :categories="categories" />
              <el-date-picker v-else-if="field.date" v-model="filters[field.key]" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间" />
              <div v-else-if="field.matchKey" class="combined-control"><el-select v-model="filters[field.matchKey]"><el-option v-for="option in field.matchOptions" :key="option.value" :value="option.value" :label="option.label" /></el-select><div v-if="field.range" class="range"><input v-model="filters[field.key + '_min']" placeholder="最小值" /><span>~</span><input v-model="filters[field.key + '_max']" placeholder="最大值" /></div><input v-else v-model="filters[field.key]" :placeholder="field.placeholder || '请输入'" /></div>
              <div v-else-if="field.range" class="range"><input v-model="filters[field.key + '_min']" placeholder="最小值" /><span>~</span><input v-model="filters[field.key + '_max']" placeholder="最大值" /></div>
              <el-select v-else-if="field.options" v-model="filters[field.key]" clearable><el-option v-for="option in field.options" :key="String(option.value)" :value="option.value" :label="option.label" /></el-select>
              <input v-else v-model="filters[field.key]" :placeholder="field.placeholder || '请输入条件'" />
            </label>
          </div>
        </template>
        <footer class="filter-actions">
          <doudian-batch-shop-scope v-model="shops" :shops="shopOptions" :disabled="confirming || submitting || (mode === 'products' && selected.length > 0)" hint="未选择时，查询、预览和创建均使用当前账号有权限的全部抖店" />
          <div class="filter-buttons"><button :disabled="loading || uploading || !validSelection" @click="loadCandidates(1)">查询商品及原图</button><button class="plain" @click="reset">重置</button></div>
        </footer>
        <p class="hint">查询用于查看商品和原主图；修改内容预览用于核对目标图片，均不会提交修改。</p>
      </section>
      <doudian-batch-common-options v-model="commonOptions" :disabled="loading || submitting" />
      <section class="panel methods">
        <h3>
          <i></i>
          修改内容
        </h3>
        <div v-for="method in methods" :key="method.id" class="rule-row main-image-rule-row">
          <el-checkbox
            :value="selectedMethod === method.id"
            class="main-image-method-name"
            @change="selectMethod(method.id)">
            方式{{ method.id }}：{{ method.name }}
          </el-checkbox>
          <div class="method-controls">
            <template v-if="method.id === 1">
              <span>查询商品及原图后，可逐商品保留、删除、调整原图并添加图片素材。</span>
            </template>
            <template v-else-if="method.id === 2">
              <el-checkbox-group v-model="deletePositions" :disabled="selectedMethod !== method.id">
                <el-checkbox v-for="n in 5" :key="n" :label="n">第{{ n }}张</el-checkbox>
                <el-checkbox label="delete_last">末尾</el-checkbox>
              </el-checkbox-group>
            </template>
            <template v-else-if="method.id === 3">
              <div class="bm-main-image__inline">
                <button
                  class="upload-box"
                  :disabled="selectedMethod !== method.id || uploading"
                  @click="openMediaSelector(3)">
                  <span>+</span>
                  <small>上传图片</small>
                </button>
                <div class="selected-images">
                  <div v-for="id in addMedia" :key="id" class="image-item">
                    <img v-if="mediaFor(id)" :src="mediaFor(id).preview_url" alt="" />
                    <button class="remove-img" :disabled="selectedMethod !== method.id" @click="removeAddedMedia(id)">
                      <i class="el-icon-close"></i>
                    </button>
                    <small v-if="mediaFor(id)">
                      {{ sourceState(mediaFor(id)) }}
                      <span v-if="mediaFor(id).task_error">：{{ mediaFor(id).task_error }}</span>
                      <button
                        v-if="mediaFor(id).task_error && mediaFor(id).request && !mediaFor(id).source_id"
                        :disabled="uploading"
                        @click="registerItem(mediaFor(id)).then(scheduleStatusPoll)">
                        重试登记
                      </button>
                    </small>
                  </div>
                </div>
              </div>
              <div class="bm-main-image__inline image-insert-position">
                <span>插入位置：</span>
                <el-select v-model="addPosition" class="position-picker" :disabled="selectedMethod !== method.id">
                  <el-option label="追加到末尾" value="append" />
                  <el-option v-for="n in 5" :key="n" :label="`第${n}张主图前`" :value="`before_${n}`" />
                </el-select>
              </div>
            </template>
            <template v-else-if="method.id === 4">
              <div class="replace-images-grid">
                <div v-for="(id, index) in replaceMedia" :key="index" class="replace-image-slot">
                  <label>第{{ index + 1 }}张</label>
                  <button
                    class="upload-box small"
                    :disabled="selectedMethod !== method.id || uploading"
                    @click="openMediaSelector(4, index)">
                    <img v-if="mediaFor(id)" :src="mediaFor(id).preview_url" alt="" />
                    <template v-else>
                      <span>+</span>
                      <small>上传</small>
                    </template>
                  </button>
                  <button
                    v-if="id"
                    class="remove-btn"
                    :disabled="selectedMethod !== method.id"
                    @click="replaceMedia.splice(index, 1, '')">
                    删除
                  </button>
                  <small v-if="mediaFor(id)">
                    {{ sourceState(mediaFor(id)) }}
                    <span v-if="mediaFor(id).task_error">：{{ mediaFor(id).task_error }}</span>
                    <button
                      v-if="mediaFor(id).task_error && mediaFor(id).request && !mediaFor(id).source_id"
                      :disabled="uploading"
                      @click="registerItem(mediaFor(id)).then(scheduleStatusPoll)">
                      重试登记
                    </button>
                  </small>
                </div>
              </div>
            </template>
            <template v-else-if="method.id === 5">
              <div class="bm-main-image__inline">
                <span>将当前首图移到第</span>
                <el-input-number
                  v-model="moveFirst"
                  class="price-number-input"
                  :min="2"
                  :max="10"
                  :step="1"
                  :precision="0"
                  controls-position="right"
                  :disabled="selectedMethod !== method.id" />
                <span>位</span>
              </div>
            </template>
            <template v-else-if="method.id === 6">
              <div class="bm-main-image__inline">
                <span>将第</span>
                <el-input-number
                  v-model="setFirst"
                  class="price-number-input"
                  :min="2"
                  :max="10"
                  :step="1"
                  :precision="0"
                  controls-position="right"
                  :disabled="selectedMethod !== method.id" />
                <span>张设为首图</span>
              </div>
            </template>
            <template v-else-if="method.id === 7">
              <el-radio-group v-model="shuffleMode" :disabled="selectedMethod !== method.id">
                <el-radio label="keep_first">首图不变位置</el-radio>
                <el-radio label="shuffle_all">首图参与打乱</el-radio>
                <el-radio label="keep_last">尾图不变位置</el-radio>
              </el-radio-group>
            </template>
            <template v-else>
              <span>按商品最低价且有图的 SKU 图片替换首图；价格相同时按 SKU ID 稳定排序，无有效图片则跳过。</span>
            </template>
          </div>
        </div>
      </section>
      <section v-if="statusError" class="panel audit-warning">
        {{ statusError }}
        <button
          @click="
            pollFailures = 0
            pollMaterialStatuses(true)
          ">
          重新读取状态
        </button>
      </section>
      <p class="preview-note">
        {{
          selectedMethod === 1
            ? '方式1在预览中直接拖拽、替换、删除和添加图片。新图片通过抖店审核后，可点击本行保存；预测和修改确认通过后才显示保存成功。'
            : '选图仅暂存图片。创建批次后验证商品最新详情，再按实际命中的店铺上传素材；素材审核及类目预测通过后才修改抖店商品。'
        }}
      </p>
      <section v-if="candidates" class="bm-main-image__preview">
        <header class="preview-summary">
          <div>
            <strong>{{ preview ? '修改内容预览' : '商品与原图查询' }}</strong>
            <span>
              共
              <b>{{ candidates.total }}</b>
              件商品
            </span>
            <template v-if="preview && preview.page_match_counts">
              <span>
                本页可修改
                <b>{{ preview.page_match_counts.ready }}</b>
              </span>
              <span>
                跳过
                <b>{{ preview.page_match_counts.skipped }}</b>
              </span>
              <span>
                待核验
                <b>{{ preview.page_match_counts.unknown }}</b>
              </span>
            </template>
          </div>
          <small v-if="!preview">只读查看当前筛选范围，不会生成目标图或提交修改。</small>
        </header>
        <p v-if="preview && selectedMethod !== 1" class="preview-note">
          本地预览不代表抖店最终结果。创建后系统将读取并验证商品详情，再为实际命中的店铺上传素材、等待审核，使用最终审核图片预测类目并核对原类目，通过后才提交完整商品修改；预测或审核失败时不会更新商品。
        </p>
        <div class="preview-table-wrap">
          <table>
            <thead>
              <tr>
                <th>商品信息</th>
                <th>{{ selectedMethod === 1 ? '主图预览（方式1 拖拽可以设置顺序）' : '主图预览' }}</th>
                <th>状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in candidates.list"
                :key="item.shop_id + ':' + item.platform_product_id"
                :class="{ 'is-excluded': isExcluded(item) }">
                <td class="product-cell">
                  <el-image
                    v-if="item.old_images && item.old_images[0]"
                    class="product-image"
                    :src="item.old_images[0]"
                    fit="cover"
                    :preview-src-list="[item.old_images[0]]" />
                  <span v-else class="product-image-placeholder">暂无主图</span>
                  <div>
                    <small>{{ shopName(item.shop_id) }}</small>
                    <p>{{ item.product_title }}</p>
                    <small>ID：{{ item.platform_product_id }}</small>
                  </div>
                </td>
                <td class="images-cell">
                  <template v-if="selectedMethod === 1">
                    <draggable
                      v-model="inlineState(item).images"
                      class="detail-images-preview"
                      draggable=".editable-image"
                      :disabled="
                        inlineBusy(inlineState(item)) ||
                        inlineState(item).preparing ||
                        inlineState(item).conflict ||
                        isExcluded(item)
                      "
                      :animation="200"
                      filter=".image-actions-overlay"
                      :prevent-on-filter="false"
                      @start="draggingImages = true"
                      @end="
                        inlineChanged(item)
                        $nextTick(() => {
                          draggingImages = false
                        })
                      ">
                      <div
                        v-for="(img, index) in inlineState(item).images"
                        :key="img.key"
                        class="image-preview-item editable-image"
                        :class="'image-' + inlineChangeType(item, img, index)"
                        title="拖拽可以设置顺序">
                        <el-image
                          :src="img.kind === 'new' ? (mediaFor(img.mediaKey) || {}).preview_url || img.url : img.url"
                          fit="cover"
                          :preview-src-list="draggingImages ? [] : inlineUrls(inlineState(item))"
                          :initial-index="index"
                          :draggable="false"
                          style="width: 100%; height: 100%; cursor: move">
                          <div slot="placeholder" class="image-loading"><i class="el-icon-loading"></i></div>
                        </el-image>
                        <div
                          v-if="changeName(inlineChangeType(item, img, index))"
                          class="change-badge"
                          :class="'badge-' + inlineChangeType(item, img, index)">
                          {{ changeName(inlineChangeType(item, img, index)) }}
                        </div>
                        <div
                          v-if="!inlineBusy(inlineState(item)) && !inlineState(item).conflict && !isExcluded(item)"
                          class="image-actions-overlay">
                          <button
                            class="icon-btn-overlay"
                            title="替换"
                            aria-label="替换"
                            :disabled="inlineState(item).preparing"
                            @click.stop="openInlineImage(item, img)">
                            <i class="el-icon-refresh"></i>
                          </button>
                          <button
                            class="icon-btn-overlay"
                            title="删除"
                            aria-label="删除"
                            :disabled="inlineState(item).preparing || inlineState(item).images.length <= 3"
                            @click.stop="deleteInlineImage(item, img)">
                            <i class="el-icon-delete"></i>
                          </button>
                        </div>
                      </div>
                      <template slot="footer">
                        <div
                          v-for="img in inlineDeletedImages(item)"
                          :key="img.key"
                          class="image-preview-item image-deleted">
                          <el-image :src="img.url" fit="cover" style="width: 100%; height: 100%" />
                          <div class="change-badge badge-deleted">已删除</div>
                          <div class="deleted-overlay"></div>
                        </div>
                        <div
                          v-if="
                            !inlineBusy(inlineState(item)) &&
                            !inlineState(item).conflict &&
                            !isExcluded(item) &&
                            inlineState(item).images.length < 10
                          "
                          class="image-preview-item add-image"
                          title="添加图片"
                          @click="openInlineImage(item)">
                          <span class="add-icon">+</span>
                        </div>
                      </template>
                    </draggable>
                    <div v-if="inlineState(item).images.some((img) => img.kind === 'new')" class="inline-audit">
                      <small v-for="img in inlineState(item).images.filter((img) => img.kind === 'new')" :key="img.key">
                        {{ inlineImageStatus(item, img) }}
                      </small>
                      <button
                        class="plain"
                        :disabled="
                          inlineState(item).preparing || inlineRefreshSeconds(item) > 0 || inlineBusy(inlineState(item))
                        "
                        @click="prepareInline(item, true)">
                        {{
                          inlineState(item).preparing
                            ? '处理中…'
                            : inlineRefreshSeconds(item) > 0
                            ? inlineRefreshSeconds(item) + '秒后刷新'
                            : '刷新审核状态'
                        }}
                      </button>
                    </div>
                  </template>
                  <div v-else class="detail-images-preview">
                    <div
                      v-for="(img, index) in previewChanges(item)"
                      :key="img.key"
                      class="image-preview-item"
                      :class="'image-' + img.change_type">
                      <el-image
                        :src="img.url"
                        fit="cover"
                        :preview-src-list="img.change_type === 'deleted' ? [] : visiblePreviewUrls(item)"
                        :initial-index="previewImageIndex(item, index)"
                        style="width: 100%; height: 100%" />
                      <div v-if="changeName(img.change_type)" class="change-badge" :class="'badge-' + img.change_type">
                        {{ changeName(img.change_type) }}
                      </div>
                      <div v-if="img.change_type === 'deleted'" class="deleted-overlay"></div>
                    </div>
                  </div>
                </td>
                <td class="status-cell">
                  <template v-if="selectedMethod === 1">
                    <span
                      :class="{
                        'is-modified': inlineDirty(inlineState(item)),
                        'is-success': inlineState(item).state === 'completed',
                        'is-failed': inlineState(item).state === 'failed' || inlineState(item).conflict
                      }">
                      {{ inlineLabel(item) }}
                    </span>
                    <small v-if="inlineState(item).error" class="inline-error">{{ inlineState(item).error }}</small>
                    <button v-if="inlineState(item).conflict" class="plain" @click="resetInline(item)">重新加载</button>
                  </template>
                  <template v-else>
                    <span class="result-state" :class="{ 'is-ready': preview && item.preview_result === 'ready' }">
                      {{ isExcluded(item) ? '已排除' : preview ? resultName(item) : '无变化' }}
                    </span>
                    <small v-if="preview && item.reason && item.reason !== 'no_change'" class="inline-error">
                      {{ item.reason }}
                    </small>
                  </template>
                </td>
                <td class="action-cell">
                  <button
                    v-if="selectedMethod === 1 && !['confirming', 'uncertain'].includes(inlineState(item).state)"
                    class="btn-save-action"
                    :disabled="!inlineCanSave(item)"
                    @click="saveInline(item)">
                    {{ inlineState(item).state === 'saving' ? '保存中...' : '保存' }}
                  </button>
                  <button
                    v-if="selectedMethod === 1 && ['confirming', 'uncertain'].includes(inlineState(item).state)"
                    class="btn-save-action"
                    :disabled="inlineState(item).preparing || inlineRefreshSeconds(item) > 0"
                    @click="queryInlineResult(item)">
                    查询结果
                  </button>
                  <el-checkbox
                    :value="isExcluded(item)"
                    :disabled="selectedMethod === 1 && inlineBusy(inlineState(item))"
                    @change="exclude(item)">
                    排除修改
                  </el-checkbox>
                </td>
              </tr>
              <tr v-if="!candidates.list.length">
                <td colspan="4" class="empty-row">暂无商品</td>
              </tr>
            </tbody>
          </table>
        </div>
        <footer class="preview-pagination">
          <el-pagination
            small
            layout="prev, pager, next"
            :current-page="candidates.page"
            :page-size="candidates.limit"
            :total="candidates.total"
            @current-change="preview ? loadPreview($event) : loadCandidates($event)" />
        </footer>
      </section>
    </main>
    <footer v-if="mode" class="bm-main-image__bottom">
      <button class="preview-action" :disabled="loading || uploading || !validSelection" @click="loadPreview(1)">
        {{ loading ? '处理中…' : '修改内容预览' }}
      </button>
      <button
        class="start"
        :disabled="selectedMethod === 1 || submitting || confirming || !previewCurrent || hasMissingSource"
        @click="createBatch">
        {{ submitting ? '提交中…' : '开始批量修改' }}
      </button>
      <label class="schedule-toggle">
        <input
          v-model="scheduled"
          type="checkbox"
          :disabled="submitting || selectedMethod === 1"
          @change="toggleSchedule" />
        定时执行
      </label>
      <button v-if="scheduled" class="time" :disabled="submitting" @click="openSchedule">
        {{ scheduledAt || '选择时间' }}
      </button>
    </footer>
    <div v-if="scheduleVisible" class="schedule-mask">
      <section class="schedule-modal">
        <header>
          <strong>定时执行</strong>
          <button @click="scheduleVisible = false">×</button>
        </header>
        <main>
          <el-date-picker
            v-model="scheduleDraft"
            class="schedule-picker"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            placeholder="选择北京时间"
            :clearable="false" />
        </main>
        <footer>
          <button class="plain" @click="scheduleVisible = false">取消</button>
          <button @click="confirmSchedule">确定</button>
        </footer>
      </section>
    </div>
    <image-selector-dialog
      :visible.sync="imageSelectorVisible"
      :type="
        imageSelectorTarget.method === 1
          ? imageSelectorTarget.imageKey
            ? 'inline_replace'
            : 'inline_add'
          : imageSelectorTarget.method === 3
          ? 'add'
          : 'replace'
      "
      :multiple="imageSelectorTarget.method !== 4 && !imageSelectorTarget.imageKey"
      upload-accept="image/jpeg,image/png"
      :upload-handler="uploadHandler"
      image-source="main_sku"
      source-selection
      @source-select="registerSources" />
    <product-selector-dialog
      @page-size-change="changeSelectorPageSize"
      :visible="selectorVisible"
      :active-tab="selectorTab"
      :products="selectorProducts"
      :selected-ids="draftSelected.map(productId)"
      :loading="selectorLoading"
      :page="selectorPage"
      :page-size="selectorPageSize"
      :page-sizes="[20, 50, 100, 500, 1000]"
      :total="selectorTab === 'selected' ? draftSelected.length : selectorTotal"
      :total-pages="selectorPages"
      :jump-page="selectorPage"
      :page-fully-selected="selectorRows.length > 0 && selectorRows.every(isSelected)"
      :product-id="productId"
      :product-key="productKey"
      :product-title="productTitle"
      :product-image="productImage"
      :product-price="productPrice"
      @tab-change="changeSelectorTab"
      @toggle-product="toggleProduct"
      @toggle-page="togglePage"
      @page-change="changeSelectorPage"
      @jump="changeSelectorPage(selectorPage)"
      @close="selectorVisible = false"
      @confirm="confirmSelected">
      <template slot="filters">
        <doudian-product-selector-filters
          v-model="selectorFilters"
          :shop-id="selectorShopId"
          :shops="shopOptions"
          :categories="categories"
          @shop-change="
            selectorShopId = $event
            loadSelector(1)
          "
          @query="loadSelector(1)" />
      </template>
    </product-selector-dialog>
  </section>
</template>

<script>
import draggable from 'vuedraggable'
import mainImageInline from './mainImageInline'
import DoudianBatchShopScope from '@/components/DoudianBatchShopScope'
import ProductSelectorDialog from '@/components/ProductSelectorDialog/ProductSelectorDialog.vue'
import DoudianProductSelectorFilters from './DoudianProductSelectorFilters.vue'
import DoudianCategoryCascader from '@/components/DoudianCategoryCascader'
import DoudianBatchCommonOptions from '@/components/DoudianBatchCommonOptions'
import ImageSelectorDialog from '@/pages/cloudGoodsBatchEdit/components/ImageSelectorDialog.vue'
import { fields, pairedFields, defaults } from './batchModifyFilters'
import {
  getAuthSuccessShopList,
  getDoudianCategories,
  getProductSelectorProducts,
  uploadDoudianMainImageSource,
  registerDoudianMainImageSource,
  getDoudianMainImageStatuses,
  getDoudianMainImageCandidates,
  previewDoudianMainImageBatch,
  createDoudianMainImageBatch
} from '@/api/main/doudianBatchEdit'

const hiddenFilterKeys = ['quality_problem', 'source_shop_name', 'source_product_id', 'source_title']
const unwrap = (r) => (r && r.data && r.data.data !== undefined ? r.data.data : r && r.data !== undefined ? r.data : r)
export default {
  name: 'BatchModifyMainImage',
  mixins: [mainImageInline],
  components: {
    draggable,
    DoudianBatchShopScope,
    ProductSelectorDialog,
    DoudianProductSelectorFilters,
    DoudianCategoryCascader,
    DoudianBatchCommonOptions,
    ImageSelectorDialog
  },
  data: () => ({
    tabs: [
      { value: 'range', label: '按范围修改' },
      { value: 'products', label: '按商品修改' },
      { value: 'product_ids', label: '按商品ID修改' }
    ],
    mode: 'range',
    fields: fields.filter((field) => !hiddenFilterKeys.includes(field.key)),
    pairedFields,
    filters: defaults(),
    shops: [],
    shopOptions: [],
    categories: [],
    idsText: '',
    selected: [],
    uploadHandler: uploadDoudianMainImageSource,
    methods: [
      { id: 1, name: '预览手动修改' },
      { id: 2, name: '删除主图' },
      { id: 3, name: '添加主图' },
      { id: 4, name: '主图替换' },
      { id: 5, name: '将当前首图移到第x位' },
      { id: 6, name: '将第x张设为首图' },
      { id: 7, name: '随机打乱' },
      { id: 8, name: '最低价SKU图替换首张主图' }
    ],
    selectedMethod: 1,
    deletePositions: [],
    addMedia: [],
    addPosition: 'append',
    replaceMedia: ['', '', '', '', ''],
    moveFirst: 2,
    setFirst: 2,
    shuffleMode: 'keep_first',
    commonOptions: { auto_generate_size_chart: false, shelf_action: 0 },
    scheduled: false,
    scheduledAt: '',
    scheduleDraft: '',
    scheduleVisible: false,
    imageSelectorVisible: false,
    imageSelectorTarget: { method: 3, index: 0 },
    media: [],
    uploading: false,
    candidates: null,
    preview: null,
    excluded: [],
    manualItems: {},
    loading: false,
    submitting: false,
    confirming: false,
    requestVersion: 0,
    previewSignature: '',
    draftSubmitted: false,
    registrationCount: 0,
    statusTimer: null,
    polling: false,
    pollFailures: 0,
    statusError: '',
    restoringDraft: false,
    selectorVisible: false,
    selectorTab: 'all',
    selectorRows: [],
    selectorPageSize: 20,
    selectorTotal: 0,
    selectorPage: 1,
    selectorShopId: '',
    selectorLoading: false,
    selectorFilters: {
      category_id: { level1: [], level2: [], level3: [] },
      platform_product_id: '',
      product_title: '',
      created_at: [],
      tab_status: ''
    },
    draftSelected: []
  }),
  computed: {
    shownFields() {
      return this.fields
        .filter((f) => !Object.values(this.pairedFields).includes(f.key))
        .map((f) =>
          this.pairedFields[f.key]
            ? {
                ...f,
                matchKey: this.pairedFields[f.key],
                matchOptions: this.fields.find((x) => x.key === this.pairedFields[f.key]).options
              }
            : f
        )
    },
    validSelection() {
      return (
        this.mode === 'range' ||
        (this.mode === 'products' && this.selected.length > 0) ||
        (this.mode === 'product_ids' && this.split(this.idsText).length > 0)
      )
    },
    hasMissingSource() {
      const ids =
        this.selectedMethod === 3 ? this.addMedia : this.selectedMethod === 4 ? this.replaceMedia.filter(Boolean) : []
      return ids.some((id) => !this.mediaFor(id)?.source_id)
    },
    payloadSignature() {
      try {
        return JSON.stringify(this.payload())
      } catch {
        return ''
      }
    },
    previewCurrent() {
      return !!this.preview && !!this.payloadSignature && this.previewSignature === this.payloadSignature
    },
    selectorPages() {
      return Math.max(
        1,
        Math.ceil((this.selectorTab === 'selected' ? this.draftSelected.length : this.selectorTotal) / this.selectorPageSize)
      )
    },
    selectorProducts() {
      return this.selectorTab === 'selected'
        ? this.draftSelected.slice((this.selectorPage - 1) * this.selectorPageSize, this.selectorPage * this.selectorPageSize)
        : this.selectorRows
    }
  },
  created() {
    this.loadOptions()
    // 暂停草稿持久化：刷新页面时不恢复旧值。
    // this.restoreDraft()
    this.visibilityHandler = () => {
      if (!document.hidden) this.pollMaterialStatuses(true)
    }
    document.addEventListener('visibilitychange', this.visibilityHandler)
  },
  beforeDestroy() {
    this.saveDraft()
    clearTimeout(this.statusTimer)
    document.removeEventListener('visibilitychange', this.visibilityHandler)
  },
  watch: {
    shops: {
      deep: true,
      handler() {
        if (this.restoringDraft) return
        this.invalidate()
        this.saveDraft()
      }
    },
    filters: {
      deep: true,
      handler() {
        if (this.restoringDraft) return
        this.invalidate()
        this.saveDraft()
      }
    },
    idsText() {
      if (this.restoringDraft) return
      this.invalidate()
      this.saveDraft()
    },
    selected() {
      if (this.restoringDraft) return
      this.invalidate()
      this.saveDraft()
    },
    payloadSignature() {
      this.saveDraft()
    },
    media: {
      deep: true,
      handler() {
        this.saveDraft()
      }
    }
  },
  methods: {
    changeSelectorPageSize(size) {
      this.selectorPageSize = Number(size)
      this.selectorPage = 1
      this.loadSelector(1)
    },
    async loadOptions() {
      try {
        const [shops, cats] = await Promise.all([getAuthSuccessShopList(), getDoudianCategories({ shop_type: 1 })])
        const s = unwrap(shops)
        this.shopOptions = Array.isArray(s) ? s : s.list || []
        const c = unwrap(cats)
        const map = (rows) =>
          (Array.isArray(rows) ? rows : []).map((x) => ({
            ...x,
            category_id: x.id || x.category_id,
            category_name: x.name || x.category_name,
            children: map(x.children || [])
          }))
        this.categories = map(Array.isArray(c) ? c : c.list || [])
      } catch (e) {
        this.$message.error(this.message(e))
      }
    },
    split(s) {
      return [
        ...new Set(
          String(s || '')
            .split(/[,，\s]+/)
            .filter(Boolean)
        )
      ]
    },
    filterPayload() {
      const f = { shop_ids: this.shops.map(Number), excluded_product_ids: [...this.excluded] }
      Object.keys(this.filters).forEach((k) => {
        if (hiddenFilterKeys.includes(k)) return
        const v = this.filters[k]
        if (v !== '' && v != null && !(Array.isArray(v) && !v.length)) f[k] = v
      })
      if (f.platform_product_id) f.platform_product_id = this.split(f.platform_product_id)
      if (this.mode !== 'range') {
        delete f.status
        delete f.created_at
        delete f.category_id
        f.platform_product_id =
          this.mode === 'products' ? this.selected.map((x) => String(x.platform_product_id)) : this.split(this.idsText)
      }
      Object.keys(f)
        .filter((k) => /_(min|max)$/.test(k))
        .forEach((k) => {
          f[k] = Number(f[k])
        })
      return f
    },
    bindings(id) {
      const item = this.mediaFor(id)
      if (!item?.source_id) throw new Error('图片来源尚未登记完成')
      return { source_id: item.source_id }
    },
    rule() {
      switch (this.selectedMethod) {
        case 1:
          return { method: 1 }
        case 2:
          if (!this.deletePositions.length) throw new Error('请选择要删除的位置')
          return { method: 2, delete_positions: this.deletePositions }
        case 3:
          if (!this.addMedia.length || this.addMedia.length > 5) throw new Error('请选择1至5张新增图片')
          return { method: 3, add_images: this.addMedia.map((id) => this.bindings(id)), add_position: this.addPosition }
        case 4:
          if (!this.replaceMedia.some(Boolean)) throw new Error('请选择至少一张替换图片')
          return { method: 4, replace_images: this.replaceMedia.map((id) => (id ? this.bindings(id) : null)) }
        case 5:
          return { method: 5, move_first_to_position: this.moveFirst }
        case 6:
          return { method: 6, set_as_first_position: this.setFirst }
        case 7:
          return { method: 7, shuffle_mode: this.shuffleMode }
        default:
          return { method: 8 }
      }
    },
    payload(includeSchedule = false) {
      const p = {
        selection_mode: this.mode,
        product_filter: this.filterPayload(),
        rule: this.rule(),
        manual_items:
          this.selectedMethod === 1
            ? Object.values(this.manualItems).filter((item) => !this.shops.length || this.shops.includes(item.shop_id))
            : [],
        common_options: { ...this.commonOptions }
      }
      if (includeSchedule && this.scheduled && this.selectedMethod !== 1) p.scheduled_at = this.scheduledAt
      return p
    },
    invalidate() {
      this.requestVersion++
      this.preview = null
      this.previewSignature = ''
    },
    switchMode(mode) {
      this.mode = mode
      this.selected = []
      this.candidates = null
      this.invalidate()
    },
    reset() {
      this.filters = defaults()
      this.excluded = []
      this.invalidate()
    },
    selectMethod(id) {
      this.selectedMethod = Number(id)
      this.methodChanged()
    },
    methodChanged() {
      if (Number(this.selectedMethod) === 1) {
        this.scheduled = false
        this.scheduledAt = ''
        this.scheduleVisible = false
      }
      this.invalidate()
      if (!this.restoringDraft) this.saveDraft()
    },
    toggleSchedule() {
      if (!this.scheduled) {
        this.scheduledAt = ''
        this.scheduleDraft = ''
        this.scheduleVisible = false
      }
    },
    openSchedule() {
      this.scheduleDraft = this.scheduledAt ? this.scheduledAt.slice(0, 16) : this.formatScheduleTime()
      this.scheduleVisible = true
    },
    confirmSchedule() {
      const ts = new Date(`${this.scheduleDraft}:00`.replace(' ', 'T') + '+08:00')
      if (!this.scheduleDraft || ts <= new Date()) return this.$message.warning('请选择未来的执行时间')
      this.scheduledAt = `${this.scheduleDraft}:00`
      this.scheduleVisible = false
    },
    formatScheduleTime(date = new Date(Date.now() + 60000)) {
      const pad = (value) => String(value).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(
        date.getMinutes()
      )}`
    },
    openMediaSelector(method, index = 0) {
      if (this.selectedMethod !== method || this.uploading) return
      this.imageSelectorTarget = { method, index }
      this.imageSelectorVisible = true
    },
    mediaFor(id) {
      return this.media.find((item) => String(item.id) === String(id) || item.key === id)
    },
    removeAddedMedia(id) {
      this.addMedia = this.addMedia.filter((value) => String(value) !== String(id))
      this.invalidate()
    },
    async registerSources(sources) {
      const target = { ...this.imageSelectorTarget }
      if (target.method !== this.selectedMethod) return this.$message.warning('修改方式已变化，请重新选图')
      if (target.method === 1) return this.acceptInlineSources(sources, target)
      if (target.method === 3 && this.addMedia.length + sources.length > 5)
        return this.$message.warning('添加主图最多选择5张')
      const offset = this.media.length
      const items = sources.map((source, index) => ({
        key: source.client_key,
        id: source.client_key,
        source_id: null,
        name: `图片素材${offset + index + 1}`,
        source_status: 'registering',
        preview_url: source.preview_url,
        task_error: '',
        request: { source_kind: source.source_kind, source_ref: source.source_ref, idempotency_key: source.client_key }
      }))
      this.media.push(...items)
      if (target.method === 3) this.addMedia.push(...items.map((item) => item.id))
      else if (target.method === 4 && items[0]) this.replaceMedia.splice(target.index, 1, items[0].id)
      this.invalidate()
      const pending = [...items]
      await Promise.all(
        Array.from({ length: Math.min(3, pending.length) }, async () => {
          while (pending.length) await this.registerItem(pending.shift())
        })
      )
      this.scheduleStatusPoll()
    },
    async registerItem(item) {
      if (!item.request) return
      this.registrationCount++
      this.uploading = true
      this.$set(item, 'task_error', '')
      this.$set(item, 'source_status', 'registering')
      try {
        const data = unwrap(await registerDoudianMainImageSource(item.request))
        if (this._isDestroyed) return
        this.mergeSource(item, { ...data, id: data.source_id })
        this.saveDraft()
      } catch (error) {
        if (!this._isDestroyed) {
          this.$set(item, 'source_status', 'registration_failed')
          this.$set(item, 'task_error', this.message(error))
        }
      } finally {
        this.registrationCount--
        this.uploading = this.registrationCount > 0
      }
    },
    mergeSource(item, source) {
      item.source_id = source.id
      item.source_status = source.source_status || source.status
      item.preview_url = source.preview_url || item.preview_url
      item.task_error = source.error_message || ''
      if (source.source_key && source.source_ref)
        item.request = {
          source_kind: source.source_kind,
          source_ref: source.source_ref,
          idempotency_key: source.source_key
        }
    },
    sourceState(item) {
      return (
        {
          registering: '正在登记图片',
          registration_failed: '图片登记失败',
          queued: '等待暂存',
          processing: '图片暂存中',
          ready: '已暂存，执行时上传抖店',
          failed: '图片暂存失败',
          unknown: '图片状态待确认'
        }[item.source_status] || '图片状态待确认'
      )
    },
    availableSources() {
      return this.media.filter((item) => item.source_id)
    },
    scheduleStatusPoll() {
      clearTimeout(this.statusTimer)
      if (!this._isDestroyed && this.pollFailures < 3)
        this.statusTimer = setTimeout(() => this.pollMaterialStatuses(), 2000)
    },
    async pollMaterialStatuses(force = false) {
      clearTimeout(this.statusTimer)
      if (this._isDestroyed || this.polling) return
      if (document.hidden) {
        this.scheduleStatusPoll()
        return
      }
      const ids = [
        ...new Set(
          this.media
            .filter(
              (item) => item.source_id && (force || ['queued', 'processing', 'unknown'].includes(item.source_status))
            )
            .map((item) => item.source_id)
        )
      ]
      const keys = this.media
        .filter((item) => !item.source_id && (force || (item.lookup_attempts || 0) < 3))
        .map((item) => item.key)
      if (!ids.length && !keys.length) return
      this.polling = true
      try {
        const batches = []
        for (let offset = 0; offset < ids.length; offset += 100)
          batches.push({ source_ids: ids.slice(offset, offset + 100) })
        for (let offset = 0; offset < keys.length; offset += 100)
          batches.push({ source_keys: keys.slice(offset, offset + 100) })
        for (const params of batches) {
          const data = unwrap(await getDoudianMainImageStatuses(params))
          if (this._isDestroyed) return
          this.media.forEach((item) => {
            const source = (data.sources || []).find(
              (value) => value.id === item.source_id || value.source_key === item.key
            )
            if (source) this.mergeSource(item, source)
            else if (params.source_keys?.includes(item.key)) {
              item.lookup_attempts = (item.lookup_attempts || 0) + 1
              if (item.lookup_attempts >= 3) item.task_error = '尚未确认来源登记，请重试登记或重新选择图片'
            }
          })
        }
        this.pollFailures = 0
        this.statusError = ''
        this.prepareVisibleInline()
        this.saveDraft()
      } catch (error) {
        this.pollFailures = error.code === 403 || error.code === 401 ? 3 : this.pollFailures + 1
        this.statusError = this.message(error)
      } finally {
        this.polling = false
        this.scheduleStatusPoll()
      }
    },
    draftKey() {
      const user = this.$store?.state?.login?.userinfo
      const merchantId = user?.mer_user_id || user?.merchant_id || user?.id
      const accountId = user?.sub_id || user?.mobile || user?.id
      return merchantId && accountId ? `dmi-draft-v3:${merchantId}:${encodeURIComponent(accountId)}` : null
    },
    saveDraft() {
      if (this.restoringDraft || this.draftSubmitted) return
      const key = this.draftKey()
      if (!key) return
      const state = {}
      ;[
        'mode',
        'shops',
        'filters',
        'idsText',
        'selectedMethod',
        'deletePositions',
        'addMedia',
        'addPosition',
        'replaceMedia',
        'moveFirst',
        'setFirst',
        'shuffleMode',
        'commonOptions',
        'manualItems',
        'inlineRows',
        'excluded'
      ].forEach((name) => {
        state[name] = this[name]
      })
      state.selected = this.selected.map((item) => ({
        shop_id: item.shop_id,
        platform_product_id: String(item.platform_product_id)
      }))
      state.media = this.media.map((item) => ({ key: item.key, id: item.id, source_id: item.source_id }))
      try {
        // 暂停草稿持久化，保留代码方便后续恢复。
        // localStorage.setItem(key, JSON.stringify(state))
      } catch {
        /* Full/disabled browser storage must not interrupt editing. */
      }
    },
    restoreDraft() {
      const key = this.draftKey()
      if (!key) return
      try {
        const state = JSON.parse(localStorage.getItem(key) || 'null')
        if (!state || !Array.isArray(state.shops) || !Array.isArray(state.media)) return
        this.restoringDraft = true
        const names = [
          'mode',
          'shops',
          'filters',
          'idsText',
          'selected',
          'selectedMethod',
          'deletePositions',
          'addMedia',
          'addPosition',
          'replaceMedia',
          'moveFirst',
          'setFirst',
          'shuffleMode',
          'commonOptions',
          'manualItems',
          'inlineRows',
          'excluded'
        ]
        names.forEach((name) => {
          if (state[name] !== undefined) this[name] = state[name]
        })
        this.media = state.media.map((item, index) => ({
          ...item,
          name: `图片素材${index + 1}`,
          source_status: 'unknown',
          preview_url: '',
          task_error: ''
        }))
        Object.values(this.inlineRows).forEach((row) => {
          row.preparing = false
          if (row.state === 'saving') row.state = 'uncertain'
          row.materials = {}
        })
        this.$nextTick(() => {
          this.restoringDraft = false
          this.pollMaterialStatuses(true)
        })
      } catch {
        this.restoringDraft = false
      }
    },
    shopName(id) {
      return (this.shopOptions.find((s) => Number(s.mer_shop_id) === Number(id)) || {}).shop_name || `店铺${id}`
    },
    async loadCandidates(page = 1) {
      if (this.loading) return
      if (!this.validSelection) return this.$message.warning('请选择商品或输入商品ID')
      const request = JSON.parse(JSON.stringify({ selection_mode: this.mode, product_filter: this.filterPayload() }))
      const scope = JSON.stringify(request)
      const version = ++this.requestVersion
      this.loading = true
      try {
        const data = unwrap(await getDoudianMainImageCandidates({ ...request, page, limit: 20 }))
        if (
          this._isDestroyed ||
          version !== this.requestVersion ||
          scope !== JSON.stringify({ selection_mode: this.mode, product_filter: this.filterPayload() })
        )
          return
        this.candidates = data
        this.reconcileInlineScope()
        this.invalidate()
      } catch (e) {
        if (!this._isDestroyed && version === this.requestVersion) this.$message.error(this.message(e))
      } finally {
        this.loading = false
      }
    },
    async loadPreview(page = 1) {
      if (this.loading) return
      if (!this.validSelection) return this.$message.warning('请选择商品或输入商品ID')
      let request
      try {
        request = JSON.parse(JSON.stringify(this.payload(false)))
        if (this.scheduled && !this.scheduledAt) throw new Error('请选择定时执行时间')
      } catch (e) {
        return this.$message.warning(e.message)
      }
      const signature = JSON.stringify(request)
      const version = ++this.requestVersion
      this.loading = true
      try {
        const data = unwrap(await previewDoudianMainImageBatch({ ...request, page, limit: 20 }))
        if (this._isDestroyed || version !== this.requestVersion || signature !== this.payloadSignature) return
        this.preview = data
        this.candidates = data
        ;(data.list || []).forEach((item) => {
          if (item && typeof item === 'object' && !item.image_changes?.length) {
            this.$set(item, 'image_changes', this.previewChanges(item))
          }
        })
        this.reconcileInlineScope()
        this.previewSignature = signature
      } catch (e) {
        if (!this._isDestroyed && version === this.requestVersion) {
          this.invalidate()
          this.$message.error(this.message(e))
        }
      } finally {
        this.loading = false
      }
    },
    async createBatch() {
      if (this.selectedMethod === 1) return this.$message.warning('方式1请使用每行保存按钮')
      if (this.submitting || this.confirming) return
      if (!this.previewCurrent || this.hasMissingSource)
        return this.$message.warning('请先完成图片来源登记和当前规则预览')
      if (this.scheduled && !this.scheduledAt) return this.$message.warning('请选择定时执行时间')
      const request = JSON.parse(JSON.stringify(this.payload(true)))
      const signature = JSON.stringify(request)
      this.confirming = true
      try {
        const scope = this.shops.length ? '所选店铺' : '全部授权店铺'
        await this.$confirm(`将修改${scope}中的 ${this.preview.total} 个候选商品，是否创建批次？`, '确认修改', {
          type: 'warning'
        })
      } catch {
        return
      } finally {
        this.confirming = false
      }
      if (this._isDestroyed) return
      try {
        if (!this.previewCurrent || this.hasMissingSource || signature !== JSON.stringify(this.payload(true)))
          return this.$message.warning('配置已变化，请重新预览并确认')
      } catch {
        return this.$message.warning('配置已变化，请重新预览并确认')
      }
      this.submitting = true
      try {
        await createDoudianMainImageBatch(request)
        this.draftSubmitted = true
        const key = this.draftKey()
        try {
          if (key) localStorage.removeItem(key)
        } catch {
          /* Storage failure must not turn a created batch into a reported API failure. */
        }
        this.$message.success('任务已创建，请查看批量修改记录')
        this.$emit('created')
      } catch (e) {
        this.$message.error(this.message(e))
      } finally {
        this.submitting = false
      }
    },
    targetOf(item) {
      return this.preview ? item.target_images || item.old_images || [] : item.old_images || []
    },
    resultName(item) {
      return item.preview_result === 'ready'
        ? '将修改'
        : item.reason === 'no_change'
        ? '无变化'
        : item.preview_result === 'skipped'
        ? '跳过'
        : '待核验'
    },
    isExcluded(item) {
      return this.excluded.includes(Number(item.id))
    },
    exclude(item) {
      const id = Number(item.id)
      this.excluded = this.isExcluded(item) ? this.excluded.filter((x) => x !== id) : [...this.excluded, id]
      this.invalidate()
    },
    openSelector() {
      this.selectorVisible = true
      this.selectorTab = 'all'
      this.draftSelected = [...this.selected]
      this.loadSelector(1)
    },
    changeSelectorTab(tab) {
      this.selectorTab = tab
      this.selectorPage = 1
      if (tab === 'all') this.loadSelector(1)
    },
    changeSelectorPage(page) {
      const next = Math.min(this.selectorPages, Math.max(1, Number(page) || 1))
      if (this.selectorTab === 'selected') this.selectorPage = next
      else this.loadSelector(next)
    },
    async loadSelector(page = 1) {
      this.selectorPage = page
      this.selectorLoading = true
      try {
        const data = unwrap(
          await getProductSelectorProducts({
            page,
            page_size: this.selectorPageSize,
            ...this.selectorFilters,
            ...(this.selectorShopId ? { shop_ids: [this.selectorShopId] } : {})
          })
        )
        this.selectorRows = data.list || []
        this.selectorTotal = data.pagination?.total || data.total || 0
      } catch (e) {
        this.$message.error(this.message(e))
      } finally {
        this.selectorLoading = false
      }
    },
    productId(x) {
      return String(x.platform_product_id)
    },
    productKey(x) {
      return `${x.shop_id}:${x.platform_product_id}`
    },
    productTitle(x) {
      return x.product_title || x.title || ''
    },
    productImage(x) {
      return x.main_image || x.img || ''
    },
    productPrice(x) {
      return x.product_price == null ? '价格待定' : `¥${Number(x.product_price).toFixed(2)}`
    },
    isSelected(x) {
      return this.draftSelected.some((y) => this.productKey(y) === this.productKey(x))
    },
    toggleProduct(x) {
      if (
        !this.isSelected(x) &&
        this.draftSelected.length &&
        Number(this.draftSelected[0].shop_id) !== Number(x.shop_id)
      )
        return this.$message.warning('按商品修改一次只能选择同一家店铺')
      this.draftSelected = this.isSelected(x)
        ? this.draftSelected.filter((y) => this.productKey(y) !== this.productKey(x))
        : [...this.draftSelected, x]
    },
    togglePage() {
      const all = this.selectorRows.every(this.isSelected)
      const shopId = Number(this.draftSelected[0]?.shop_id || this.selectorRows[0]?.shop_id)
      if (!all && this.selectorRows.some((x) => Number(x.shop_id) !== shopId))
        return this.$message.warning('请先按店铺筛选后再全选')
      this.selectorRows.forEach((x) => {
        if (this.isSelected(x) === all) this.toggleProduct(x)
      })
    },
    async confirmSelected() {
      this.selected = [...this.draftSelected]
      if (this.selected.length) this.shops = [Number(this.selected[0].shop_id)]
      this.selectorVisible = false
      this.invalidate()
    },
    message(e) {
      return e.response?.data?.message || e.message || '请求失败，请稍后重试'
    }
  }
}
</script>

<style scoped src="./batch-modify.css"></style>
<style scoped>
.batch-head nav button.mode-range.active {
  border-bottom-color: #1677ff;
  background: #f0f7ff;
  color: #1677ff;
}
.batch-head nav button.mode-products.active,
.batch-head nav button.mode-product_ids.active {
  border-bottom-color: #722ed1;
  background: #f9f0ff;
  color: #722ed1;
}
.method-controls {
  display: flex;
  flex-basis: 100%;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 10px 0 0 22px;
  color: #666;
}
.method-controls > .el-checkbox-group,
.method-controls > .el-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
}
.method-controls > .el-select,
.method-controls .image-picker {
  width: 280px;
  max-width: 100%;
}
.method-controls .position-picker {
  width: 200px;
  max-width: 100%;
}
.method-controls .image-insert-position {
  flex-basis: 100%;
  margin-top: 10px;
}
.method-controls .replace-slot {
  display: flex;
  align-items: center;
  gap: 8px;
}
.method-controls ::v-deep .el-checkbox__inner {
  width: 14px;
  height: 14px;
  border-color: #d9c98d;
  border-radius: 3px;
}
.method-controls ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #d4a946;
  background: #d4a946;
}
.main-image-method-name ::v-deep .el-checkbox__inner {
  width: 14px;
  height: 14px;
  border-color: #d9c98d;
  border-radius: 3px;
}
.main-image-method-name ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #d4a946;
  background: #d4a946;
}
.main-image-method-name ::v-deep .el-checkbox__label {
  color: #1a1a2e;
  font-size: 13px;
  font-weight: 600;
}
.bm-main-image__inline {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
}
.batch-modify .upload-box {
  display: inline-flex;
  box-sizing: border-box;
  width: 80px;
  min-width: 80px;
  height: 80px;
  min-height: 80px;
  flex: 0 0 80px;
  padding: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #d9d9d9;
  border-radius: 4px;
  background: #fafafa;
  color: #999;
  cursor: pointer;
  transition: all 0.3s;
}
.upload-box:hover {
  border-color: #1677ff;
  color: #1677ff;
}
.upload-box:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.upload-box.small {
  width: 80px;
  height: 80px;
}
.upload-box span {
  font-size: 24px;
  line-height: 1;
}
.upload-box small {
  margin-top: 8px;
  font-size: 11px;
}
.upload-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 2px;
}
.selected-images {
  display: flex;
  flex-wrap: wrap;
  gap: 18px 10px;
}
.image-item {
  position: relative;
  width: 160px;
  min-height: 80px;
  height: auto;
}
.image-item > img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
}
.image-item .remove-img {
  position: absolute;
  top: -8px;
  left: 68px;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #ff4d4f;
  color: #fff;
  line-height: 20px;
}
.image-item > small {
  display: block;
  width: 160px;
  overflow-wrap: anywhere;
  color: #777;
  font-size: 10px;
}
.image-item > small button,
.replace-image-slot > small button {
  height: auto;
  padding: 0;
  background: transparent;
  color: #1677ff;
  font-size: 10px;
}
.replace-images-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 16px;
  width: 100%;
}
.replace-image-slot {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.replace-image-slot > label {
  color: #666;
  font-size: 12px;
}
.replace-image-slot .remove-btn {
  width: 80px;
  padding: 4px 10px;
  border: 1px solid #ff4d4f;
  border-radius: 4px;
  background: #fff;
  color: #ff4d4f;
}
.replace-image-slot > small {
  max-width: 160px;
  overflow-wrap: anywhere;
  color: #777;
  font-size: 10px;
}
.price-number-input {
  width: 160px;
  height: 28px;
  display: inline-flex;
  vertical-align: middle;
  line-height: 28px;
}
.price-number-input ::v-deep .el-input-number__increase,
.price-number-input ::v-deep .el-input-number__decrease {
  box-sizing: border-box;
  width: 22px;
  right: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  line-height: 1;
  color: #606266;
  background: #f5f7fa;
  border-color: #dcdfe6;
}
.price-number-input ::v-deep .el-input-number__increase {
  top: 1px;
  height: 13px;
  border-radius: 0 3px 0 0;
}
.price-number-input ::v-deep .el-input-number__decrease {
  bottom: 1px;
  height: 13px;
  border-radius: 0 0 3px 0;
}
.price-number-input.is-disabled ::v-deep .el-input-number__increase,
.price-number-input.is-disabled ::v-deep .el-input-number__decrease,
.price-number-input ::v-deep .el-input-number__increase.is-disabled,
.price-number-input ::v-deep .el-input-number__decrease.is-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}
.price-number-input ::v-deep .el-input-number__increase i,
.price-number-input ::v-deep .el-input-number__decrease i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
  line-height: 1;
}
.price-number-input ::v-deep .el-input__inner {
  padding-left: 15px;
  padding-right: 26px;
  text-align: left;
}
.selection-filter-actions {
  border-top: 1px solid #f0f0f0;
  padding-top: 9px;
}
.bm-main-image__preview {
  overflow: hidden;
  margin-top: 14px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}
.preview-summary {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid #e0e0ec;
  font-size: 12px;
}
.preview-summary > div {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 16px;
}
.preview-summary strong {
  font-weight: 600;
}
.preview-summary b {
  color: #1677ff;
}
.preview-summary small {
  color: #999;
}
.preview-note {
  margin: 0;
  padding: 8px 14px;
  color: #667085;
  font-size: 12px;
  line-height: 1.6;
}
.preview-note.warning {
  color: #b97932;
}
.preview-table-wrap {
  overflow-x: auto;
}
.bm-main-image__preview table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  font-size: 12px;
}
.bm-main-image__preview th {
  padding: 8px 12px;
  background: #f5f0e8;
  color: #666;
  font-size: 11px;
  font-weight: 500;
  text-align: left;
}
.bm-main-image__preview td {
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 11px;
  vertical-align: middle;
}
.bm-main-image__preview tbody tr:hover {
  background: #fafcff;
}
.product-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}
.product-cell > div {
  min-width: 0;
}
.product-cell p {
  margin: 3px 0;
  overflow-wrap: anywhere;
}
.product-cell small {
  color: #999;
  line-height: 16px;
}
.product-image,
.product-image-placeholder {
  width: 64px;
  height: 64px;
  flex: 0 0 64px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #f5f5f5;
}
.product-image-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 10px;
}
.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.preview-image {
  width: 64px;
  height: 64px;
  flex: 0 0 64px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}
.result-state.is-ready {
  color: #389e0d;
}
.result-state.is-skipped {
  color: #b97932;
}
.action-cell {
  text-align: center;
  white-space: nowrap;
}
.row-action {
  height: 24px;
  margin: 2px;
  padding: 0 8px;
  border: 1px solid #91caff;
  border-radius: 3px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 10px;
}
.row-action.plain {
  border-color: #e0e0ec;
  background: #fff;
  color: #666;
}
.empty-row {
  padding: 24px !important;
  color: #999;
  text-align: center;
}
.preview-pagination {
  display: flex;
  justify-content: flex-end;
  min-height: 48px;
  padding: 10px 14px;
  border-top: 1px solid #ebeef5;
}
.bm-main-image__bottom {
  position: fixed;
  left: var(--merchant-sidebar-width, 210px);
  right: 0;
  bottom: 0;
  z-index: 20;
  display: flex;
  width: auto;
  max-width: none;
  min-width: 0;
  box-sizing: border-box;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  border-top: 1px solid #e0e0ec;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  font-size: 12px;
}
.bm-main-image__bottom button {
  height: 30px;
  padding: 0 14px;
  border: 0;
  border-radius: 4px;
  color: #fff;
}
.bm-main-image__bottom .preview-action {
  background: #1677ff;
}
.bm-main-image__bottom .start {
  margin-left: auto;
  margin-right: 50px;
  padding: 0 28px;
  background: #52c41a;
}
.bm-main-image__bottom .time {
  border: 1px solid #e0e0ec;
  background: #fff;
  color: #666;
}
.bm-main-image__bottom button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.schedule-toggle {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}
.schedule-picker {
  max-width: 240px;
}
.audit-warning {
  color: #b42318;
  background: #fff1f0;
  border: 1px solid #ffccc7;
}
.sku-audit-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 10px;
}
.sku-audit-list article {
  display: flex;
  align-items: center;
  gap: 8px;
}
.sku-audit-list img {
  width: 64px;
  height: 64px;
  object-fit: cover;
}
.sku-audit-list article > div {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
@media (max-width: 960px) {
  .bm-main-image__bottom {
    left: 0;
  }
  .filters {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 720px) {
  .filters {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .bm-main-image__bottom .start {
    margin-left: 0;
  }
}
@media (max-width: 520px) {
  .filters {
    grid-template-columns: 1fr;
  }
  .bm-main-image__bottom {
    left: 0;
    flex-wrap: wrap;
    gap: 6px;
    padding: 8px 12px;
  }
  .bm-main-image__bottom .preview-action {
    display: inline-flex;
  }
  .bm-main-image__bottom .start {
    margin: 0 0 0 auto;
    padding: 0 12px;
  }
  .schedule-picker {
    width: 160px;
  }
}
</style>

<style scoped>
.detail-images-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 4px 0;
}

/* 图片预览项 */
.image-preview-item {
  position: relative;
  width: 80px;
  height: 80px;
  border: 2px solid #d9d9d9;
  border-radius: 4px;
  overflow: hidden;
  transition: all 0.3s;
  flex-shrink: 0;
}

.image-preview-item:hover {
  border-color: #1890ff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* 变化标识 */
.change-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  padding: 2px 6px;
  border-radius: 2px;
  font-size: 10px;
  color: #fff;
  font-weight: 500;
  z-index: 2;
}

.badge-added {
  background-color: #52c41a;
}

.badge-replaced {
  background-color: #1890ff;
}

.badge-moved {
  background-color: #faad14;
}

.badge-deleted {
  background-color: #ff4d4f;
}

/* 图片变化样式 */
.image-added {
  border-color: #52c41a;
  box-shadow: 0 0 0 2px rgba(82, 196, 26, 0.2);
}

.image-replaced {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.image-moved {
  border-color: #faad14;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
}

.image-deleted {
  border-color: #ff4d4f;
  opacity: 0.6;
}

/* 删除图片遮罩 */
.deleted-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.image-deleted::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 10%;
  right: 10%;
  height: 2px;
  background-color: #ff4d4f;
  transform: translateY(-50%) rotate(-15deg);
  z-index: 2;
}

/* 图片加载中 */
.image-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  color: #999;
}

.image-loading i {
  font-size: 20px;
}

/* 图片操作按钮遮罩层 */
.image-preview-item:hover .image-actions-overlay {
  opacity: 1;
}

.image-actions-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 20px;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 0;
  opacity: 0;
  transition: opacity 0.2s;
}

.image-actions-overlay .icon-btn-overlay {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 20px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.image-actions-overlay .icon-btn-overlay:hover:not(:disabled) {
  width: 20px;
  height: 20px;
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
}

.image-actions-overlay .icon-btn-overlay:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

/* 添加图片按钮 */
.image-preview-item.add-image {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #d9d9d9;
  background: #fafafa;
  cursor: pointer;
  transition: all 0.2s;
}

.image-preview-item.add-image:hover {
  border-color: #1677ff;
  background: #f0f7ff;
}

.add-icon {
  font-size: 24px;
  color: #999;
}

.image-preview-item.add-image:hover .add-icon {
  color: #1677ff;
}

.bm-main-image__preview th:first-child {
  width: 26%;
}
.bm-main-image__preview th:nth-child(3) {
  width: 100px;
  text-align: center;
}
.bm-main-image__preview th:last-child {
  width: 190px;
  text-align: center;
}
.bm-main-image__preview .action-cell {
  white-space: nowrap;
  vertical-align: middle;
}
.bm-main-image__preview .action-cell button {
  min-width: 82px;
  height: 30px;
  padding: 0 12px;
  border: 1px solid #91caff;
  border-radius: 5px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 12px;
  line-height: 28px;
}
.bm-main-image__preview .action-cell button + .el-checkbox {
  margin-left: 8px;
}
.bm-main-image__preview .action-cell button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.bm-main-image__preview tr.is-excluded {
  background: #e5e5e5;
  color: #777;
}
.status-cell {
  text-align: center;
  vertical-align: middle;
  color: #999;
}
.is-modified,
.is-success {
  color: #52c41a;
}
.is-failed {
  color: #f56c6c;
}
.inline-error {
  display: block;
  max-width: 190px;
  color: #f56c6c;
  overflow-wrap: anywhere;
}
.inline-audit {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #909399;
}
.inline-audit small {
  flex-basis: 100%;
}
@media (max-width: 900px) {
  .bm-main-image__preview table {
    min-width: 900px;
  }
}
</style>
